_updateUserThunk